import React, { Component } from 'react';
import {Form, Control, Errors } from "react-redux-form";
import { isRequired, required, minValue } from "../field_validations";
import _ from 'lodash';

class ContentFormActivity extends Component {
	render(){
		const { activityGroup, verificationMedia, status } = this.props;
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="activities.edit" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="group_id" className="label">Grupo de Actividades <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".group_id" id="group_id" errors={{required}} validateOn="change">
										<option value=" " defaultValue>--- Grupo de Actividades ---</option>
										{_.map(activityGroup.list, (option, key) => {
											return <option key={key} value={option.id}>{option.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".group_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{required: 'Debes seleccionar un grupo de actividades '}} />
							</div>

							<div className="control">
								<div className="field">
									<label htmlFor="amount" className="label">Monto <span className="small has-text-danger">*</span></label>
									<div className="control has-icons-left">
										<Control.text model=".amount" id="amount" className="input" type="number" step=".01" min="0" errors={{isRequired, minValue: minValue(0)}} validateOn="change"/>
										<span className="icon is-small is-left"><i className="fa fa-usd"/></span>
										<Errors model=".amount" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
									</div>
								</div>
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="name" className="label">Nombre de la Actividad <span className="small has-text-danger">*</span></label>
								<Control.textarea model=".name" id="name" className="textarea" placeholder="Nombre de la Actividad" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="verification_media_id" className="label">Medio de Verificación <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".verification_media_id" id="verification_media_id" errors={{required}} validateOn="change">
										<option value="">--- Medio de Verificación ---</option>
										{_.map(verificationMedia.list, (option, key) => {
											return <option key={key} value={option.id}>{option.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".verification_media_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Seleccionar un Medio'}} />
							</div>

							<div className="control">
								<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".status_id" id="status" className="select" validateOn="change">
										<option value="">--- Estatus ---</option>
										{_.map(status.data, (stat, k) => {
											return <option value={stat.id} key={k}>{stat.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
						</div>
						<br/>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<Control.button model="activities" className="button is-large" onClick={() => this.props.history.push('/proigualdad/actividades')}>Regresar</Control.button>
							</div>

							<div className="control">
								<Control.button model="activities" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	_handleSubmit(values) {
		this.props.saveActivity(values)
	}

	_validateSave(){
		const {activities} = this.props;
		let ac = _.find(activities.permissions, (o) => {return o==='Create'});
		let au = _.find(activities.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(activities.edit) && activities.edit.id){
			if(au){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(activities.edit) && _.isEmpty(activities.edit.id)){
			if(ac){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default ContentFormActivity;


// WEBPACK FOOTER //
// ./src/elements/activities/form.jsx